import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import React from "react";
import { ContainerModule } from "../ContainerModule";
import { ContentModule } from "../ContentModule";
import { ModuleType } from "../ModuleType";
var ColumnContent = function(param) {
    var content = param.content;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: content.map(function(part) {
            switch(part.type){
                case ModuleType.Container:
                    return /*#__PURE__*/ _jsx(ContainerModule, _object_spread({}, part));
                case ModuleType.ContentModule:
                    return /*#__PURE__*/ _jsx(ContentModule, _object_spread({}, part));
                default:
                    return null;
            }
        })
    });
};
export { ColumnContent };
